import { preventDefaultEvent } from '@terraware/web-components/utils';
export default preventDefaultEvent;
